export default "__VITE_ASSET__0l75A6vU__"